import { commonApi } from '@common/utils/baseQuery';

import { IUserStats } from '@features/auth/api/authApi.type';
import { IAddToBasket, IBasket, IPlaceBet } from '@features/basket/api/basketApi.type';
import { IEditTicketRequest, IEditTicketResponse } from '@features/basket/edit/betEdit';

export const basketApi = commonApi.injectEndpoints({
  endpoints: (build) => ({
    fetchBasketItems: build.query<IBasket, void>({
      query: () => '/basket',
    }),
    addOddToBasket: build.mutation<IBasket, IAddToBasket>({
      query: (body) => ({
        url: '/basket',
        body,
        method: 'POST',
      }),
    }),
    placeBet: build.mutation<IBasket, IPlaceBet>({
      query: ({ items, betType, cardNo }) => ({
        url: '/basket/place',
        body: { ...items, betType, cardNo },
        method: 'POST',
      }),
    }),
    deleteItem: build.mutation<IBasket, string | number>({
      query: (oddId) => ({
        url: `/basket/${oddId}`,
        method: 'DELETE',
      }),
    }),
    clearBasket: build.mutation<IBasket, void>({
      query: () => ({
        url: '/basket',
        method: 'DELETE',
      }),
    }),
    setBasketRatio: build.mutation<void, IUserStats['basketRatio']>({
      query: (value) => ({
        url: `/basket/settings/ratio/${value}`,
        method: 'POST',
      }),
    }),
    editTicket: build.mutation<IEditTicketResponse, IEditTicketRequest>({
      query: ({ ticketNo, odds, preview }) => ({
        url: `/basket/ticket/${ticketNo}/edit`,
        body: { odds, preview },
        method: 'POST',
      }),
      invalidatesTags: (result, error, { preview }) => (!error && !preview && result?.status === 'BET_EDIT_SAVED') ? [ 'UserBets' as never ] : [],
    }),
  }),
});

export const {
  useFetchBasketItemsQuery,
  useAddOddToBasketMutation,
  usePlaceBetMutation,
  useDeleteItemMutation,
  useClearBasketMutation,
  useSetBasketRatioMutation,
  useEditTicketMutation,
} = basketApi;
